import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus, FaShoppingBag, FaBolt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useParams } from "react-router-dom";
import "./ProductDetail.css";
import Swal from "sweetalert2";
import { useCart } from "../Context/CartContext";
import BASE_URL from "../config";


function ProductDetail()
{

const {id}=useParams();
const { addToCart } = useCart();
const [product,setProduct]=useState(null);
const [quantity,setQuantity]=useState(1);
const [currentImage, setCurrentImage] = useState(0);



useEffect(()=>{

fetch(`${BASE_URL}/api/products/${id}`)
.then(res=>res.json())
.then(data=>{

setProduct(data.product);

})
.catch(err=>console.log(err));


},[id]);

const images = [
  product?.image,
  product?.image2,
].filter(Boolean);

useEffect(() => {

  if (images.length <= 1) return;

  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  }, 3000);

  return () => clearInterval(interval);

}, [images.length]);

if(!product){

return (
<div className="loading">
Loading Product...
</div>
)

}



return(

<section className="product-detail">


<div className="product-wrapper">


{/* IMAGE */}

<div className="product-gallery">

  <div className="image-box">

    <button
      className="slider-btn left"
      onClick={() =>
        setCurrentImage(
          currentImage === 0
            ? images.length - 1
            : currentImage - 1
        )
      }
    >
      <FaChevronLeft />
    </button>

    <img
      src={`https://sahscents.xpertoneevents.com/uploads/${images[currentImage]}`}
      alt={product.name}
    />

    <button
      className="slider-btn right"
      onClick={() =>
        setCurrentImage(
          currentImage === images.length - 1
            ? 0
            : currentImage + 1
        )
      }
    >
      <FaChevronRight />
    </button>

  </div>

  <div className="thumbnail-row">

    {images.map((img, index) => (

      <img
        key={index}
        src={`https://sahscents.xpertoneevents.com/uploads/${img}`}
        alt=""
        className={currentImage === index ? "active-thumb" : ""}
        onClick={() => setCurrentImage(index)}
      />

    ))}

  </div>

</div>





{/* DETAILS */}

<div className="product-content">


<span className="category">
PREMIUM COLLECTION
</span>



<h1>
{product.name}
</h1>



<div className="rating">
★★★★★
<span>(Customer Reviews)</span>
</div>




<h2>
AED {product.price}
</h2>



<p className="description">
{product.description}
</p>




<div className="quantity-box">

<p>Quantity</p>


<div className="quantity-control">


<button
onClick={()=>{
if(quantity>1)
setQuantity(quantity-1)
}}
>
<FaMinus/>
</button>



<span>
{quantity}
</span>



<button
onClick={()=>{
setQuantity(quantity+1)
}}
>
<FaPlus/>
</button>


</div>


</div>





<div className="actions">


<button
className="cart-btn"
onClick={() => {

addToCart(product, quantity);

Swal.fire({
  toast: true,
  position: "top-end",
  icon: "success",
  title: `${product.name} added to cart`,
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

}}
>

<FaShoppingBag/>

ADD TO CART

</button>



<button className="buy-btn">

<FaBolt/>
BUY NOW

</button>


</div>

</div>

</div>
<div className="extra-info">

  <div className="extra-item">
    <span>🚚</span>
    <div>
      <h4>Fast UAE Delivery</h4>
      <p>Quick and reliable shipping across all Emirates.</p>
    </div>
  </div>

  <div className="extra-item">
    <span>🔒</span>
    <div>
      <h4>Secure Payments</h4>
      <p>Protected checkout with trusted payment processing.</p>
    </div>
  </div>

  <div className="extra-item">
    <span>🎁</span>
    <div>
      <h4>Luxury Packaging</h4>
      <p>Elegantly packed, making every order feel premium.</p>
    </div>
  </div>

  <div className="extra-item">
    <span>🌿</span>
    <div>
      <h4>Long-Lasting Fragrance</h4>
      <p>Designed to keep your favourite spaces fresh for weeks.</p>
    </div>
  </div>

</div>
<section className="product-information">

  <div className="product-information-container">

    {/* <div className="section-heading">
      <span>SAH PREMIUM COLLECTION</span>
      <h2>Product Information</h2>
      <p>
        Everything you need to know about your SAH scented pouch.
      </p>
    </div> */}

    <div className="info-grid">

      {/* <div className="info-card">

        <h3>📦 What's Included</h3>

        <ul>
          <li>1 Premium Scented Pouch with Vintage Flag Design</li>
          <li>1 Extra Patch Pad for Extended Freshness</li>
          <li>1 SAH Essence Bottle for Easy Refilling</li>
        </ul>

      </div> */}

      {/* <div className="info-card">

        <h3>🚗 Perfect For</h3>

        <ul>
          <li>Cars & SUVs</li>
          <li>Closets & Wardrobes</li>
          <li>Gym Bags & Drawers</li>
          <li>Luggage & Small Spaces</li>
        </ul>

      </div> */}

      {/* <div className="info-card">

        <h3>🌿 Why Choose SAH?</h3>

        <ul>
          <li>Safe & Non-Toxic Materials</li>
          <li>Shatter-Proof Refill Bottle</li>
          <li>Long-Lasting Premium Fragrance</li>
          <li>Reusable & Eco Friendly</li>
        </ul>

      </div> */}

      <section className="product-information">

  <div className="product-information-container">

    <div className="section-heading">
      <span>SAH PREMIUM COLLECTION</span>
      <h2>Product Information</h2>
      <p>
        Everything you need to know about your SAH scented pouch.
      </p>
    </div>

    <div className="info-grid">

      <div className="info-card">

        <h3>📦 What's Included</h3>

        <ul>
          <li>1 Premium Scented Pouch with Vintage Flag Design</li>
          <li>1 Extra Patch Pad for Extended Freshness</li>
          <li>1 SAH Essence Bottle for Easy Refilling</li>
        </ul>

      </div>

      <div className="info-card">

        <h3>🚗 Perfect For</h3>

        <ul>
          <li>Cars & SUVs</li>
          <li>Closets & Wardrobes</li>
          <li>Gym Bags & Drawers</li>
          <li>Luggage & Small Spaces</li>
        </ul>

      </div>

      <div className="info-card">

        <h3>🌿 Why Choose SAH?</h3>

        <ul>
          <li>Safe & Non-Toxic Materials</li>
          <li>Shatter-Proof Refill Bottle</li>
          <li>Long-Lasting Premium Fragrance</li>
          <li>Reusable & Eco Friendly</li>
        </ul>

      </div>

      <div className="info-card">

        <h3>🌍 Available Collections</h3>

        <div className="country-tags">

          <span>India</span>
          <span>Jordan</span>
          <span>UAE</span>
          <span>USA</span>
          <span>France</span>
          <span>Brazil</span>
          <span>Morocco</span>
          {/* <span>More...</span> */}

        </div>

      </div>

    </div>

    <div className="bottom-note">

      <h2>Every Mood Has A Scent.</h2>

      <p>
        Crafted to bring elegance, freshness and personality wherever you go.
      </p>

    </div>

  </div>

</section>

    </div>

    {/* <div className="bottom-note">

      <h2>Every Mood Has A Scent.</h2>

      <p>
        Crafted to bring elegance, freshness and personality wherever you go.
      </p>

    </div> */}

  </div>

</section>

</section>


)

}


export default ProductDetail;